import React, { Component } from 'react';
import { CalendarXIcon, BatteryLowIcon, BrainIcon, AwardIcon, ArrowRightIcon } from 'lucide-react';
type Point = {
  icon: ComponentType<{
    className?: string;
    strokeWidth?: number;
  }>;
  trigger: string;
  body: string;
};
const points: Point[] = [{
  icon: CalendarXIcon,
  trigger: 'I weekend non sono più tuoi.',
  body: 'Sacrifichi domeniche a progettare invece di vivere la famiglia.'
}, {
  icon: BatteryLowIcon,
  trigger: 'A casa, lavori un secondo turno.',
  body: 'Dopo 6 ore in classe, prepari ancora schede e verifiche.'
}, {
  icon: BrainIcon,
  trigger: 'I tuoi alunni si bloccano su frazioni e problemi.',
  body: 'Cerchi un metodo chiaro che funzioni davvero in classe.'
}, {
  icon: AwardIcon,
  trigger: 'Vuoi essere "la maestra brava".',
  body: 'Quella con un programma che impressiona Dirigente e genitori.'
}];
export function ForWhomSection() {
  return <section className="w-full bg-bg-dark py-16 sm:py-24 px-4 relative overflow-hidden" data-id="element-218">
      {/* Background accents */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full pointer-events-none opacity-60" style={{
      background: 'radial-gradient(circle, rgba(234,88,12,0.08) 0%, transparent 70%)'
    }} aria-hidden="true" data-id="element-219" />
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full pointer-events-none opacity-50" style={{
      background: 'radial-gradient(circle, rgba(16,185,129,0.06) 0%, transparent 70%)'
    }} aria-hidden="true" data-id="element-220" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-221">
        {/* Section header — compact */}
        <div className="text-center mb-8 sm:mb-10" data-id="element-222">
          <span className="inline-flex items-center gap-2 text-primary font-black text-[11px] sm:text-xs uppercase tracking-[0.2em] bg-primary/10 border border-primary/20 px-4 py-1.5 rounded-full mb-3 sm:mb-4" data-id="element-223">
            👀 Ti riconosci?
          </span>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main tracking-tight leading-[1.05] mb-2 sm:mb-3" data-id="element-224">
            Una sola di queste?
            <br className="hidden sm:block" data-id="element-225" />
            <span className="text-primary" data-id="element-226"> Allora è per te.</span>
          </h2>
        </div>

        {/* Points grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4" data-id="element-227">
          {points.map((point, i) => {
          const Icon = point.icon;
          return <div key={i} className="relative flex items-start gap-3 sm:gap-4 bg-bg-alt rounded-2xl p-4 sm:p-5 border border-border-light hover:border-primary/60 transition-colors group" data-id="element-228">
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-primary/10 border border-primary/30 flex items-center justify-center flex-shrink-0 group-hover:bg-primary/20 group-hover:border-primary/60 transition-colors" data-id="element-229">
                  <Icon className="w-5 h-5 sm:w-6 sm:h-6 text-primary" strokeWidth={2.25} data-id="element-230" />
                </div>
                <div className="min-w-0 flex-1" data-id="element-231">
                  <p className="text-text-main font-black text-base sm:text-lg leading-tight mb-1" data-id="element-232">
                    {point.trigger}
                  </p>
                  <p className="text-text-sec text-[13px] sm:text-[15px] leading-snug" data-id="element-233">
                    {point.body}
                  </p>
                </div>
              </div>;
        })}
        </div>

        {/* Bottom self-qualification CTA — tight */}
        <div className="mt-6 sm:mt-8 bg-bg-alt border-2 border-primary/40 rounded-2xl p-4 sm:p-6 relative overflow-hidden shadow-[0_0_40px_rgba(234,88,12,0.12)]" data-id="element-234">
          <div className="absolute inset-0 pointer-events-none opacity-50" style={{
          background: 'radial-gradient(ellipse at center, rgba(234,88,12,0.10) 0%, transparent 70%)'
        }} aria-hidden="true" data-id="element-235" />
          <div className="relative z-10 flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-236">
            <p className="text-text-main font-black text-lg sm:text-2xl leading-tight text-center sm:text-left" data-id="element-237">
              ✋ Sì? Allora{' '}
              <span className="text-primary" data-id="element-238">questo Kit è per te.</span>
            </p>
            <a href="#pricing" style={{
            boxShadow: '0 0 20px rgba(57,255,20,0.55), 0 8px 24px rgba(57,255,20,0.35)'
          }} className="inline-flex items-center justify-center gap-2 font-black text-sm sm:text-base px-6 py-3 sm:px-7 sm:py-3.5 rounded-xl border-2 border-white/30 whitespace-nowrap uppercase tracking-tight transition-transform hover:scale-[1.03] active:scale-[0.98] text-[#FFFFFF] bg-[#22C55E] w-full sm:w-auto" data-id="element-239">
              Voglio il Kit
              <ArrowRightIcon className="w-4 h-4" strokeWidth={3} data-id="element-240" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}